import React, { useEffect, useRef, useState } from 'react'
import injectStyles from 'react-jss'
import { Section, SectionRow } from 'Components/Section'
import { Col } from 'react-bootstrap'
import { styles } from './style'
import MissionChat from './ChatWindow'
import { useSelector } from 'react-redux'
import { getConversation } from '../../../../shared/websockets/chat/chat'
import { getMessageProps } from '../../../../Components/Chat/ChatMain/util'
import { authorization } from '../../../../Module/Auth/Auth'

const Chat = ({ classes, mission }) => {
  const {
    id: missionId,
    spyInformation: {
      spyDetails: { reportReason },
    },
  } = mission
  const [isLoadedConversations, setIsLoadingConversations] = useState(false)
  const [messages, setMessages] = useState([])
  const { id: currentUserId } = authorization.getUser()

  const chatRef = useRef(null)

  const websockets = useSelector(state => state.websockets)

  useEffect(() => {
    if (chatRef.current && chatRef.current.children[0]) {
      chatRef.current.scrollTo(0, chatRef.current.scrollHeight)
    }
  }, [messages])

  useEffect(() => {
    if (websockets.connected) {
      !isLoadedConversations && setIsLoadingConversations(true)
      getConversation({ missionId })
    }
  }, [websockets.connected])

  useEffect(() => {
    const currentConversation = websockets.conversationsByMissionIds[missionId]

    if (!currentConversation) {
      return
    }

    const messages = currentConversation.orderedMessages.reduce(
      (acc, messageId) => {
        const message = websockets.messages[messageId]

        if (!message || !message.payload) {
          return acc
        }

        const author = websockets.users[message.userId] || {}

        const formatedMessage = getMessageProps({
          messageData: message,
          currentConversation,
          author,
          currentUserId: +currentUserId,
        })

        acc.unshift(formatedMessage)
        return acc
      },
      [],
    )

    setMessages(messages)
  }, [websockets.conversations, websockets.messages, websockets.users])

  return (
    <Section title={'Onsite Manager report'}>
      <SectionRow>
        <Col xs={12}>
          <h4>Spy Feedback Form</h4>
          {reportReason && reportReason.length
            ? reportReason.split(',').map((reason, index) => (
                <p>
                  {index + 1}.{reason}
                </p>
              ))
            : '-'}
        </Col>
      </SectionRow>

      <SectionRow>
        <Col xs={12}>
          <h4>Spy Chat</h4>
          <div className={classes.chatWrapper} ref={chatRef}>
            <MissionChat
              messages={messages}
              isLoadedConversations={isLoadedConversations}
            />
          </div>
        </Col>
      </SectionRow>
    </Section>
  )
}

export default injectStyles(styles)(Chat)



// WEBPACK FOOTER //
// ./src/Containers/Mission/Details/Chat/index.js